<div class="notificaciones-theme notificaciones-container">
  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
    <h1 class="page-title notif-heading mb-0">Notificaciones institucionales</h1>
    <a routerLink="/notificaciones/nueva" class="btn btn-notif-primary">Nueva notificación</a>
  </div>

  <div class="filtros-bar row g-2 align-items-end mb-3">
    <div class="col-12 col-md-3">
      <label class="form-label">Tipo de entrega</label>
      <select class="form-select" [value]="filtroTipoEntrega()" (change)="filtroTipoEntrega.set($any($event.target).value)">
        <option value="">Todas</option>
        <option value="INMEDIATA">Inmediata</option>
        <option value="PROGRAMADA">Programada</option>
      </select>
    </div>

    <div class="col-12 col-md-4">
      <label class="form-label">Nombre interno</label>
      <input type="text" class="form-control" placeholder="Buscar por nombre interno"
             [value]="filtroNombre()" (input)="filtroNombre.set($any($event.target).value)">
    </div>

    <div class="col-12 col-md-3">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="incluirEliminadas"
               [checked]="filtroIncluirEliminadas()" (change)="filtroIncluirEliminadas.set($any($event.target).checked)">
        <label class="form-check-label" for="incluirEliminadas">Incluir eliminadas</label>
      </div>
    </div>

    <div class="col-12 col-md-2">
      <button type="button" class="btn btn-notif-buscar w-100" (click)="buscar()">Buscar</button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-hover align-middle">
      <thead>
        <tr>
          <th>Nombre interno</th>
          <th>Tipo de entrega</th>
          <th>Fecha y hora de programación</th>
          <th>Fecha de envío</th>
          <th>Estado</th>
          <th class="text-center">Auditoría</th>
        </tr>
      </thead>
      <tbody>
        @if (store.cargando()) {
          <tr><td colspan="6" class="text-center text-muted py-4">Cargando...</td></tr>
        } @else {
          @for (n of store.paginacion().contenido; track n.id) {
            <tr class="clickable-row" (click)="abrirFila(n)">
              <td><span class="notif-table-link">{{ n.nombreInterno }}</span></td>
              <td>
                <span class="badge" [class.badge-notif-programada]="n.tipoEntrega === 'PROGRAMADA'" [class.badge-notif-inmediata]="n.tipoEntrega === 'INMEDIATA'">
                  {{ n.tipoEntrega === 'INMEDIATA' ? 'Inmediata' : 'Programada' }}
                </span>
              </td>
              <td>
                @if (n.tipoEntrega === 'PROGRAMADA' && n.fechaProgramacion) {
                  {{ formatearFecha(n.fechaProgramacion) }}
                } @else {
                  -
                }
              </td>
              <td>
                @if (n.fechaEnvio) {
                  {{ formatearFecha(n.fechaEnvio) }}
                  @if (n.cantidadDestinatarios != null) {
                    <span class="text-muted small">— {{ n.cantidadDestinatarios }} afiliados</span>
                  }
                } @else if (n.tipoEntrega === 'PROGRAMADA') {
                  Pendiente
                } @else {
                  -
                }
              </td>
              <td>
                <span class="badge" [class.badge-notif-positiva]="n.estado === 'ACTIVA'" [class.badge-notif-negativa]="n.estado === 'ELIMINADA'">
                  {{ n.estado === 'ACTIVA' ? 'Activa' : 'Eliminada' }}
                </span>
              </td>
              <td class="text-center">
                <button type="button" class="btn-icon-notif" aria-label="Ver auditoría" title="Auditoría"
                        [disabled]="!n.fechaEnvio"
                        (click)="$event.stopPropagation(); abrirAuditoria(n)">
                  <span class="material-icons" aria-hidden="true">content_paste_search</span>
                </button>
              </td>
            </tr>
          } @empty {
            <tr><td colspan="6" class="text-center text-muted py-4">No hay notificaciones para mostrar.</td></tr>
          }
        }
      </tbody>
    </table>

    <app-paginacion
      [pagina]="store.filtros().pagina"
      [tamanoPagina]="store.filtros().tamanoPagina"
      [hayMas]="store.paginacion().hayMas"
      [cargando]="store.cargando()"
      (paginaCambio)="onCambiarPagina($event)"
      (tamanoPaginaCambio)="onCambiarTamanoPagina($event)" />
  </div>
</div>
